module.exports = __webpack_public_path__ + "img/icon_select_arrow_black.3a9f64ff.svg";